import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react';
import React from 'react';

const ConfirmationView = ({
  onConfirmClose,
  message,
  callbackFunction,
  submitLoading,
  cancelRef,
  isOpen,
  setIsOpen,
  submitBtnText,
}) => {
  const BtnText = submitBtnText || 'Delete';
  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onConfirmClose}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader color="brand.white" fontSize="16px" bg="brand.red">
            Please confirm
          </AlertDialogHeader>

          <AlertDialogBody>{message}</AlertDialogBody>

          <AlertDialogFooter>
            <Button
              ref={cancelRef}
              onClick={()=>{setIsOpen(false)}}
              variant="cancel-button"
            >
              Cancel
            </Button>
            <Button
              _hover={{ background: 'brand.red' }}
              onClick={callbackFunction}
              ml={3}
              isLoading={submitLoading}
            >
              {BtnText}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
export default ConfirmationView;
